/**
 * Progressive Loader Configuration
 *
 * Defines the preloading queue for components
 */

import { progressiveLoader } from "../utils/LazyLoadingUtils";

/**
 * Initialize progressive loading queue
 * Priority levels: 1 (lowest) to 3 (highest)
 */
export const initializeProgressiveLoading = () => {
  // High priority - User interaction likely
  progressiveLoader.addToQueue(
    "products",
    () => import("../components/products/ProductViewer"),
    3,
  );
  progressiveLoader.addToQueue(
    "aiservices",
    () => import("../components/aiservices/AIServiceViewer"),
    3,
  );
  progressiveLoader.addToQueue(
    "magazine",
    () => import("../components/pages/MagazinePage"),
    3,
  );

  // Medium priority - Account & business pages
  progressiveLoader.addToQueue(
    "business",
    () => import("../components/business/BusinessOverviewPage"),
    2,
  );
  progressiveLoader.addToQueue(
    "user",
    () => import("../components/account/UserPage"),
    2,
  );
  progressiveLoader.addToQueue(
    "topup",
    () => import("../components/account/TopUpPage"),
    2,
  );
  progressiveLoader.addToQueue(
    "usage",
    () => import("../components/account/ViewUsagePage"),
    2,
  );

  // Low priority - Less frequently visited
  progressiveLoader.addToQueue(
    "about",
    () => import("../components/pages/AboutUsPage"),
    1,
  );
  progressiveLoader.addToQueue(
    "careers",
    () => import("../components/careers/JobViewer"),
    1,
  );

  // Start preloading after a short delay to avoid blocking initial render
  const preloadTimer = setTimeout(() => {
    progressiveLoader.loadAll();
  }, 2000);

  return () => clearTimeout(preloadTimer);
};
